import { render, staticRenderFns } from "./XmSidebar.vue?vue&type=template&id=2124681e&scoped=true"
import script from "./XmSidebar.vue?vue&type=script&lang=js"
export * from "./XmSidebar.vue?vue&type=script&lang=js"
import style0 from "./XmSidebar.vue?vue&type=style&index=0&id=2124681e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124681e",
  null
  
)

export default component.exports